/* ============================================================================
   nuud US — sticky buy bar
   ----------------------------------------------------------------------------
   Mirrors the buy box's current selection and submits the same form.

   Two things worth knowing:

   1. The reveal is driven by IntersectionObserver watching the buy box's own
      button, not by a scroll handler wrapped in requestAnimationFrame. rAF does not fire in a
      backgrounded tab, which makes an rAF-gated bar look broken under
      automated testing and in background tabs.

   2. The bar toggles `is-visible`, and the CSS in section-sticky.css keys off
      exactly that class. If you rename one, rename both.
   ========================================================================= */
(function () {
  'use strict';

  function boot() {
    var bar = document.querySelector('[data-sticky-bar]');
    var box = document.querySelector('[data-buy-box]');
    if (!bar || !box) return;

    var els = {
      title: bar.querySelector('[data-sticky-title]'),
      sub:   bar.querySelector('[data-sticky-sub]'),
      image: bar.querySelector('[data-sticky-image]'),
      cta:   bar.querySelector('[data-sticky-cta]'),
      price: bar.querySelector('[data-sticky-price]')
    };

    bar.hidden = false;
    document.body.classList.add('has-sticky-bar');

    /* ------------------------------------------------------------- reveal */
    /* Visible whenever the real button is not on screen: on first paint,
       while the visitor is still up in the hero (2026-09-22, Robert: a paid
       visitor should never have to hunt for the button), and again once the
       buy box has scrolled past. It hides only while the button it duplicates
       is itself in view, so the two never sit on top of each other.

       Watching the BUTTON rather than the whole buy box matters on a phone:
       the box is taller than the screen, so "box intersecting" was true while
       the button was still a screen below. */
    var watch = box.querySelector('[data-submit]') || box;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(watch);
    } else {
      bar.classList.add('is-visible');
    }

    /* ------------------------------------------------------------- mirror */
    function sync(detail) {
      if (!detail || !detail.pack) return;
      var pack = detail.pack;
      if (els.sub)   els.sub.textContent = pack.name + ' · ' + pack.contents;
      if (els.image && pack.image) { els.image.src = pack.image; }

      // The price the buy box is showing, in whatever mode is selected.
      var priceEl = box.querySelector('[data-price]');
      if (els.price && priceEl) els.price.innerHTML = priceEl.innerHTML;

      var live = box.querySelector('[data-submit]');
      if (els.cta && live) {
        els.cta.textContent = live.textContent;
        els.cta.disabled = live.disabled;
      }
    }

    document.addEventListener('buybox:change', function (e) { sync(e.detail); });

    // Both scripts are deferred, so buy-box.js has already run its first render
    // and fired `buybox:change` before this listener existed. Without this the
    // bar shows its placeholder title and an EMPTY button until the visitor
    // touches the pack picker. Read the state buy-box.js parked on the element.
    sync(box.buyboxState);

    // The bar has no form of its own: it submits the buy box's, so there is
    // exactly one source of truth for what goes in the cart.
    if (els.cta) {
      els.cta.addEventListener('click', function () {
        var form = box.querySelector('[data-buy-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
